// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.project-portfolio-table__actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.project-portfolio-table__actions__filter__select {
  width: 250px;
}
.project-portfolio-table__table {
  width: 100%;
  background-color: white;
  margin: 32px 0;
  border-radius: 4px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.16);
}
.project-portfolio-table__table__extra-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  padding: 12px 16px;
  min-height: 45px;
}
.project-portfolio-table__table__extra-header__title .pui-headline {
  font-weight: bold;
  color: #4a4a4a;
  margin: 0;
}
.project-portfolio-table__table .is-subgroup-cell {
  background-color: #f5f5f5;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
